import { FC, ReactNode } from 'react';
import { DisconnectOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

type ConnectBtnProps = {
  conected?: boolean;
  connectLabel: string;
  disconnectLabel: string;
  defaultLabel: string;
  icon: ReactNode;
  loading?: boolean;
  onDefaultClick: () => void;
  onConnect: () => void;
  onDisconnect: () => void;
};

export const ConnectBtn: FC<ConnectBtnProps> = ({
  conected,
  loading,
  connectLabel,
  disconnectLabel,
  defaultLabel,
  icon,
  onDefaultClick,
  onConnect,
  onDisconnect,
}) => {
  return conected ? (
    <Space.Compact style={{ marginRight: 10 }}>
      <Button
        type="primary"
        onClick={onDefaultClick}
        loading={loading}
        icon={icon}
      >
        {defaultLabel}
      </Button>
      <Tooltip title={disconnectLabel}>
        <Button
          type="primary"
          danger
          icon={<DisconnectOutlined />}
          onClick={onDisconnect}
        />
      </Tooltip>
    </Space.Compact>
  ) : (
    <Button
      icon={icon}
      onClick={onConnect}
      loading={loading}
      style={{ marginRight: 10 }}
    >
      {connectLabel}
    </Button>
  );
};
